import { Mutation, MutationCache, Query, QueryCache, QueryClient } from "react-query";
import { refreshTokenHandler } from "./refreshToken";
// import { restoreCache } from "./cachePersistence";
import { AxiosError } from "axios";

export const disableRefreshToken = "disableRefreshToken" as const;

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: 0,
            keepPreviousData: true,
            staleTime: 1000 * 10, // 10 seconds
            cacheTime: 1000 * 60 * 60 * 24, // 24 hours
            refetchOnWindowFocus: false,
            refetchOnReconnect: true,
        },
        mutations: {
            retry: 0,
        },
    },
    queryCache: new QueryCache({
        onError: (error: unknown, query: Query<unknown, unknown, unknown>) => {
            const disableKey = query.meta?.[disableRefreshToken];
            const isRefreshEnabled = disableKey === undefined;
            if (isRefreshEnabled) {
                queryErrorHandler(error, query);
            }
        },
        onSuccess: () => {
            // [ds] persistCache was breaking user impersonation, I disable it temporarily
            // persistCache(queryClient);
        },
    }),
    mutationCache: new MutationCache({
        onError: (
            error: unknown,
            variables: unknown,
            context: unknown,
            mutation: Mutation<unknown, unknown, unknown, unknown>,
        ) => {
            const disableKey = mutation.options.meta?.[disableRefreshToken];
            const isRefreshEnabled = disableKey === undefined;
            if (isRefreshEnabled) {
                mutationErrorHandler(error, variables, context, mutation);
            }
        },
    }),
});

// restoreCache(queryClient);

const queryErrorHandler = (error: unknown, query: Query) => {
    const status = (error as AxiosError).response?.status;
    if (status !== 401) {
        return;
    }

    refreshTokenHandler(error, query);
};

const mutationErrorHandler = (
    error: unknown,
    variables: unknown,
    _context: unknown,
    mutation: Mutation<unknown, unknown, unknown, unknown>,
) => {
    const status = (error as AxiosError).response?.status;
    if (status !== 401) {
        return;
    }

    refreshTokenHandler(error, undefined, mutation, variables);
};
